import { type UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { Season, SeasonResponse } from "~types/season.ts";

export const useUpdateSeason = (options: UseMutationOptions<SeasonResponse, unknown, Partial<Season>> = {}) => {
  const request = useApi();
  const queryClient = useQueryClient();
  const { sport, organizationId, seasonId } = useParams();

  return useMutation<SeasonResponse, unknown, Partial<Season>, unknown>({
    mutationFn: (body: Partial<Season>) =>
      request(`${sport}/o/${organizationId}/seasons/${seasonId}`, {
        method: "PUT",
        body: body,
      }),
    ...options,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["seasons", sport, organizationId, seasonId] });
    },
  });
};
